module.exports = __webpack_public_path__ + "static/media/item4.b175c886.jpg";